import { FieldRenderProps } from 'react-final-form';
import { Form, Radio, RadioProps } from 'semantic-ui-react';
import React from 'react';
import styled from 'styled-components';

export const PxRadioSc = styled(Radio)`

  &.ui.radio.checkbox .box,
  &.ui.radio.checkbox label {
    padding-left: 1.45714em;
  }
`;

interface FinalFormRadioProps extends FieldRenderProps {
  radioDefinition?: RadioProps,
  disabled?: boolean
}

const FinalFormRadio = (
    {
      input,
      disabled,
      radioDefinition,
      ...restProps
    }: FinalFormRadioProps) => {

  return (
      <Form.Field>
        <PxRadioSc
            onClick={(param: React.FormEvent<HTMLInputElement>, data: RadioProps) => input.onChange(data.value)}
            checked={radioDefinition && input.value === radioDefinition.value}
            disabled={disabled}
            {...radioDefinition}
            {...restProps}
        />
      </Form.Field>
  )
};

export default FinalFormRadio;
